import { NavCategory } from "../types/nav-category.type";

export const CATEGORY_ACCENTS: Record<NavCategory, string[]> = {
	world: ['#ff8a3d'],
	places: ['#2ec4ff', '#1fb0e5'],
	people: ['#3ddc97', '#28c48a', '#1eb17c', '#139d6d'],
	items: ['#f2b25f', '#e9a74f', '#dc9a3f'],
	story: ['#ff6b6b', '#f85a5a'],
	cosmology: ['#a97bff', '#9b6ef0', '#8c60e2'],
	media: ['#6ba6ff', '#5a97f0', '#4a88e2'],
};